import { TRUSTED_BY } from '../data/trustedBy';

// Continuous-drift logo marquee ("trusted by"). `variant="subtle"` is the
// quieter homepage treatment; `variant="prominent"` is the larger About
// page treatment. Pure-CSS loop (duplicated track) — no scroll listeners.
export default function TrustedByMarquee({ variant = 'subtle' }) {
  if (!TRUSTED_BY.length) return null;
  const loop = [...TRUSTED_BY, ...TRUSTED_BY];
  const prominent = variant === 'prominent';

  return (
    <div
      className="trusted-marquee overflow-hidden select-none"
      data-testid={`trusted-by-marquee-${variant}`}
    >
      <div
        className="trusted-marquee-track flex items-center w-max"
        style={{
          gap: prominent ? '5rem' : '3.5rem',
          animationDuration: prominent ? '34s' : '26s',
        }}
      >
        {loop.map((brand, i) => (
          <img
            key={`${brand.name}-${i}`}
            src={brand.logo}
            alt={brand.name}
            title={brand.name}
            loading="lazy"
            draggable={false}
            className="trusted-marquee-logo shrink-0 w-auto object-contain"
            style={{ height: prominent ? 34 : 18 }}
          />
        ))}
      </div>
    </div>
  );
}
